<script>
  import currentIdx from '../store/currentIdx';
  import fieldValues from '../store/fieldValues';
  import Form from '../components/Form.svelte';
  import InputField from '../components/InputField.svelte';

  export let title;
  export let description;
</script>

<Form
  {title}
  {description}
  handleNext={currentIdx.incrementIndex}
  isDisabled={!$fieldValues['lastName'] || !$fieldValues['firstName']}>
  <InputField
    label="LastName"
    placeholder="Harris"
    value={$fieldValues['lastName'] || ''}
    isRequired
    on:input={e => fieldValues.setField('lastName', e.detail.value)} />
  <InputField
    label="FirstName"
    placeholder="Rich"
    value={$fieldValues['firstName'] || ''}
    isRequired
    on:input={e => fieldValues.setField('firstName', e.detail.value)} />
</Form>
